import { adminCompaniesEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiCompanyHandler } from "@/services/shared";
import type { ApiCompanyType, CompanyType } from "@/types";

interface ApiEnableResponseInterface {
    company?: ApiCompanyType,
    data?: ApiCompanyType,
    message?: string,
}

export const enableCompanyHandler = async (id: number | string): Promise<CompanyType> => {
    const response = await axiosClient.put<ApiEnableResponseInterface>(adminCompaniesEndpoints.enable(id));

    const company = response.data.data ?? response.data.company;

    if (!company) throw new Error("Company payload missing in enable response");

    return transformApiCompanyHandler(company);
};
